const KNACK_GREEN_BASE_URL =
  process.env.REACT_APP_KNACK_GREEN_URL ||
  "https://esg.goveva.com/gapi/api/v1/oauth/resource-request/goveva";

const KNACK_GREEN_COMPANY_ID =
  process.env.REACT_APP_KNACK_GREEN_COMPANY_ID || "69896597b7bfa2696e9d64bc";

export const getKnackGreenRedirectUrl = (token) =>
  `${KNACK_GREEN_BASE_URL}?id_token=${encodeURIComponent(
    token,
  )}&company_id=${KNACK_GREEN_COMPANY_ID}`;
